import React from 'react';
import { Button } from '@ps-design-system/components/Button';
import LearnMoreButtonStrings from './strings';

const LearnMoreButton = () => {
  return (
    <div className="CalSyncActionButtons_button">
      <Button variant="text-only" className="underline">
        <a
          href="https://support.peerspace.com/hc/en-us/articles/360015812591-Can-I-sync-a-calendar-with-Peerspace"
          target="_blank"
          rel="noopener noreferrer"
        >
          {LearnMoreButtonStrings.learMore}
        </a>
      </Button>
    </div>
  );
};

export default LearnMoreButton;
